import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => styles(theme));

function AuthBodyContent ({ ...otherProps }) {
    const classes = useStyles();
    return (
        <Typography
            classes={{ root: classes.root }}
            color="primary"
            {...otherProps}
        />
    );
}

const styles = (theme) => ({
    root: {
        fontSize: 18,
        lineHeight: '21px'
    },
});

export default AuthBodyContent;